<template>
  <div
    v-if="technician"
    :class="[
      'flex gap-4 w-full',
      `resource-cell-${technician.id}`,
      `resource-cell-${technician.user_id}`,
      { 'ml-4': !collapsed }
    ]"
  >
    <div class="flex-shrink-0">
      <Avatar
        :alt="technician.full_name"
        :src="technician.avatar.url"
        :status="technician.is_clocked_in ? 'online' : 'offline'"
        :initials="getInitials(technician)"
      />
    </div>

    <div
      v-if="!collapsed"
      class="shrink-0 flex flex-col truncate text-left w-[65%]"
    >
      <a
        class="truncate font-medium text-gray-900 w-full"
        :title="technician.full_name"
        :href="link ? technician.show_path : null"
      >
        {{ technician.full_name }}
        <a
          v-if="!link"
          :href="technician.show_path"
          class="ml-1 text-xxs relative -top-[2px] text-gray-500"
        >
          <i class="fa-regular fa-arrow-up-right-from-square" />
        </a>
      </a>
      <div
        class="text-xs text-gray-500 font-normal w-full"
        :title="technician.department?.name"
      >
        <div class="truncate w-full">
          {{
            technician.installer
              ? "Installer"
              : capitalize(technician.skill_level || "--")
          }}
          <span v-if="technician.department?.name">•</span>
          {{ technician.department?.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import Avatar from "@/components/Seranova/Indicator/Avatar.vue";
import { capitalize, getInitials } from "@/mixins";
import { useEventCalendar } from "@/SchedulerV2/useEventCalendar";
import { ResourceAPIResponse, TimelineResource } from "@/typings/scheduler";

const { resources } = useEventCalendar();
const props = withDefaults(
  defineProps<{
    resource: TimelineResource;
    collapsed?: boolean;
    link?: boolean;
  }>(),
  { link: true, collapsed: false }
);
const technician = computed<ResourceAPIResponse | undefined>(() =>
  resources.value.find((resource) => resource.id === props.resource.id)
);
</script>

<style scoped></style>
